// Garlic by Urban Nest — storefront + admin design tokens (mirrors mobile app theme.ts)
export const colors = {
  surface: "#FCFBF8",
  onSurface: "#2C2925",
  surfaceSecondary: "#F4EFE6",
  onSurfaceSecondary: "#4A4641",
  surfaceTertiary: "#EBE5DB",
  onSurfaceTertiary: "#5B5650",
  surfaceInverse: "#2C2925",
  onSurfaceInverse: "#FCFBF8",

  brand: "#4A5F45",
  brandPrimary: "#4A5F45",
  onBrandPrimary: "#FCFBF8",
  brandDark: "#3A4E38",
  brandLight: "#D4E0D0",

  accent: "#F5CBB6",
  accentLight: "#FAE5D6",
  accentDark: "#E8A98E",
  onAccent: "#3D1A19",

  brandSecondary: "#C5D1C5",
  brandTertiary: "#E9E2D8",

  success: "#A7C4B5",
  warning: "#E3C099",
  error: "#DDA7A5",
  info: "#B5C8D4",
  sale: "#E8A98E",

  border: "#EBE5DB",
  borderStrong: "#C2BAB0",
  divider: "#EBE5DB",
  mutedText: "#8B857D",

  tileRose: "#F5D6D0",
  tilePeach: "#F5CBB6",
  tileMint: "#D4E0D0",
  tileSand: "#EAD9C4",
  tileLilac: "#DAD1E4",
  tileSky: "#CDDAE0",
  tileCream: "#F4EFE6",
};

export const tilePalette = [
  colors.tilePeach,
  colors.tileRose,
  colors.tileMint,
  colors.tileSand,
  colors.tileLilac,
  colors.tileSky,
  colors.tileCream,
];

export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48 };
export const radius = { sm: 0, md: 4, lg: 8, pill: 999 };

export const adminColors = {
  bg: "#FAF6EF",
  surface: "#FFFFFF",
  surfaceAlt: "#F3EBDD",
  surfaceMuted: "#EFE6D6",
  onSurface: "#1F1A14",
  onSurfaceSecondary: "#5C5347",
  mutedText: "#8E8578",
  primary: "#B45F3B",
  primaryHover: "#9E4E2E",
  onPrimary: "#FFFFFF",
  primarySoft: "#EAD6C8",
  primarySoftText: "#7A3B22",
  success: "#4F7A48",
  successSoft: "#DEEAD8",
  warning: "#B27A2E",
  warningSoft: "#F1E1C1",
  danger: "#B4341F",
  dangerSoft: "#F3D7CE",
  info: "#3F6478",
  infoSoft: "#D5E1E8",
  border: "#E5DBC8",
  borderStrong: "#C9BCA1",
  divider: "#EFE6D6",
  overlay: "rgba(31,26,20,0.42)",
};

export const adminColorsDark = {
  bg: "#141210",
  surface: "#1E1B17",
  surfaceAlt: "#26221C",
  surfaceMuted: "#302B23",
  onSurface: "#F5EFE3",
  onSurfaceSecondary: "#B8AE9D",
  mutedText: "#867E6F",
  primary: "#D07A55",
  primaryHover: "#B96140",
  onPrimary: "#141210",
  primarySoft: "#3A2A1F",
  primarySoftText: "#EAC9B5",
  success: "#77A46E",
  successSoft: "#233223",
  warning: "#D3A05C",
  warningSoft: "#3A2E17",
  danger: "#DC6B54",
  dangerSoft: "#3A1E17",
  info: "#75A2B7",
  infoSoft: "#1F2F38",
  border: "#3A342A",
  borderStrong: "#5B5343",
  divider: "#2A251F",
  overlay: "rgba(0,0,0,0.55)",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
